import { createContext, useContext } from 'react';

export const NavKeyboardCtx = createContext({ kbFocusedId: null, kbOpenIds: new Set() });
export const useNavKeyboard = () => useContext(NavKeyboardCtx);
